/* eslint-disable complexity */
import { TFunction } from 'next-i18next'
import { Project } from 'src/core/models'
import { getDateFormattedSmall } from 'src/core/helpers'

const EMPTY = '-'

export const certificationSections = (project: Project, t: TFunction) => [

  /* Global Fields */
  {
    label: t('Projects.Fields.Validator'),
    value: project.validator,
    show: true
  },
  {
    label: t('Projects.Fields.FirstVerifier'),
    value: project.first_verifier,
    show: !['biodiversity', 'carbon_forward'].includes(project.kind)
  },
  {
    label: t('Projects.Fields.Status'),
    value: project.status,
    show: project.kind !== 'carbon_forward'
  },

  /* Biodiversity Fields */
  {
    label: t('Projects.TypeOfBiome'),
    value: project.type_of_biome_ecosystem,
    show: project.kind === 'biodiversity'
  },
  {
    label: t('Projects.Fields.Methodology'),
    value: project.methodology,
    show: ['biodiversity', 'carbon_forward'].includes(project.kind)
  },
  {
    label: t('Projects.Fields.Standard'),
    value: project.standard,
    show: ['biodiversity', 'carbon_forward'].includes(project.kind)
  },

  /* Compensation Certification Fields */
  {
    label: t('Projects.Fields.Type'),
    value: project.type,
    show: ['compensation', 'carbon_forward'].includes(project.kind)
  },
  {
    label: t('Projects.Fields.Mechanism'),
    value: project.mechanism,
    show: ['compensation', 'carbon_forward'].includes(project.kind)
  },
  {
    label: t('Projects.Fields.CreditStart'),
    value: getDateFormattedSmall(project.credit_start),
    show: ['compensation', 'biodiversity', 'carbon_forward'].includes(project.kind) && project.credit_start
  },
  {
    label: t('Projects.Fields.CreditEnd'),
    value: getDateFormattedSmall(project.credit_end),
    show: ['compensation', 'biodiversity', 'carbon_forward'].includes(project.kind) && project.credit_end
  },
  {
    label: t('Projects.Form.ComplementaryStandards'),
    value: project.complementary_standards,
    show: ['compensation', 'carbon_forward'].includes(project.kind) && project.complementary_standards
  },
  {
    label: t('Projects.Form.QuantificationMethodology'),
    value: project.quantification_methodology,
    show: ['compensation', 'carbon_forward'].includes(project.kind) && project.quantification_methodology
  },

  /* Energy Certification Fields */
  {
    label: t('Projects.Fields.EnergySourceType'),
    value: project.energy_type,
    show: project.is_energy_type
  },
  {
    label: t('Projects.Fields.GenerationCentralName'),
    value: project.central_name,
    show: project.is_energy_type
  },
  {
    label: t('Projects.Fields.StandardType'),
    value: project.standard_energy_type,
    show: project.is_energy_type
  },
  /* File Certfication Fields */
  {
    label: t('Projects.Fields.ValidationDocumentation'),
    value: EMPTY,
    show: project.kind === 'compensation' && (!project.validation_report && !project.verification_report)
  },
  {
    label: t('Projects.Fields.ValidationReport'),
    value: project.validation_report,
    isLink: true,
    show: ['compensation', 'carbon_forward'].includes(project.kind) && project.validation_report
  },
  {
    label: t('Projects.Form.MonitoringReport'),
    value: project.verification_report,
    isLink: true,
    show: project.kind === 'compensation' && project.verification_report
  },
  /* Energy Certification Files */
  {
    label: t('Projects.Fields.ValidationDocumentation'),
    value: EMPTY,
    show: project.kind === 'energy' && (
      !project.start_up_date_of_installation &&
      !project.resulting_from_the_issuer &&
      !project.device_registration_request
    )
  },
  {
    label: t('Projects.Fields.DeviceDoc'),
    value: project.device_registration_request,
    isLink: true, show: project.kind === 'energy' && project.device_registration_request
  },
  {
    label: t('Projects.Fields.DateDoc'),
    value: project.resulting_from_the_issuer,
    isLink: true,
    show: project.kind === 'energy' && project.resulting_from_the_issuer
  },
  {
    label: t('Projects.Fields.ResultingDoc'),
    value: getDateFormattedSmall(project.start_up_date_of_installation),
    show: project.kind === 'energy' && project.start_up_date_of_installation
  },
]
